import React, { useState } from 'react'
import { FormattedMessage } from '~/translations/utils'
import { Control } from 'react-hook-form'
import { Controller } from 'react-hook-form'
import { TextField, TextAreaField } from '~/components/common/Form'

type Props = {
  control: Control<any>
  tab: 'new' | 'current' | 'task'
  address?: boolean
}

const NewClient: React.FC<Props> = ({ tab, control, address = false }) => {
  const [contact, setContact] = useState<Boolean>(false)

  return (
    <>
      <Controller
        name={'name'}
        control={control}
        render={renderProps => (
          <TextField
            label={intl.formatMessage({
              id: 'ticket / add / new client / name',
            })}
            renderProps={renderProps}
            horizontal={false}
            small={true}
          />
        )}
        rules={{
          required:
            tab == 'new'
              ? intl.formatMessage({
                  id: 'client / validate / error / empty name',
                })
              : false,
        }}
      />

      <div className="field is-horizontal">
        <div className="field-body">
          <Controller
            name={'nip'}
            control={control}
            defaultValue={''}
            render={renderProps => (
              <TextField
                label={intl.formatMessage({
                  id: 'ticket / add / new client / nippesel',
                })}
                renderProps={renderProps}
                horizontal={false}
                small={true}
              />
            )}
          />

          <Controller
            name={'phone'}
            control={control}
            defaultValue={''}
            render={renderProps => (
              <TextField
                label={intl.formatMessage({
                  id: 'ticket / add / new client / phone',
                })}
                renderProps={renderProps}
                horizontal={false}
                small={true}
              />
            )}
          />

          <Controller
            name={'email'}
            control={control}
            defaultValue={''}
            render={renderProps => (
              <TextField
                label={intl.formatMessage({
                  id: 'ticket / add / new client / email',
                })}
                renderProps={renderProps}
                horizontal={false}
                small={true}
              />
            )}
            rules={{
              required: false,
              pattern: {
                value: /^\S+@\S+$/i,
                message: intl.formatMessage({
                  id: 'client / validate / error / email',
                }),
              },
            }}
          />
        </div>
      </div>

      {address && (
        <Controller
          name={'address'}
          control={control}
          defaultValue={''}
          render={renderProps => (
            <TextAreaField
              label={intl.formatMessage({
                id: 'ticket / add / new client / address',
              })}
              renderProps={renderProps}
              horizontal={false}
              small={true}
            />
          )}
        />
      )}

      <div className="field">
        <label className="checkbox">
          <input type="checkbox" onChange={() => setContact(!contact)} />{' '}
          <FormattedMessage id="ticket / add / new client / contact" />
        </label>
      </div>
      {contact && (
        <div className="field is-horizontal">
          <div className="field-body">
            <Controller
              name={'contactName'}
              control={control}
              defaultValue={''}
              render={renderProps => (
                <TextField
                  label={intl.formatMessage({
                    id: 'ticket / add / new client / contact / name',
                  })}
                  renderProps={renderProps}
                  horizontal={false}
                  small={true}
                />
              )}
            />

            <Controller
              name={'contactPhone'}
              control={control}
              defaultValue={''}
              render={renderProps => (
                <TextField
                  label={intl.formatMessage({
                    id: 'ticket / add / new client / contact / phone',
                  })}
                  renderProps={renderProps}
                  horizontal={false}
                  small={true}
                />
              )}
            />

            <Controller
              name={'contactEmail'}
              control={control}
              defaultValue={''}
              render={renderProps => (
                <TextField
                  label={intl.formatMessage({
                    id: 'ticket / add / new client / contact / email',
                  })}
                  renderProps={renderProps}
                  horizontal={false}
                  small={true}
                />
              )}
            />
          </div>
        </div>
      )}
    </>
  )
}

export default NewClient
